<template>
  <div class="w-full">
    <vs-card
      id="compliance-donut-loading"
      class="
        vs-con-loading__container
        px-2
        widget-card
        altura
        ligthMode
        darkModeCard
      "
      style="position: sticky"
    >
      <vs-row>
        <vs-col>
          <card-header :title="$t('compliance_by_status')"></card-header>
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col>
          <div class="body-card-widget">
            <vue-apex-charts
              class="mt-12 mb-8"
              type="donut"
              height="250%"
              :options="chartOptions"
              :series="series"
            />
          </div>
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import CardHeader from './CardHeader.vue'
//requests
import request from '@/http/requests/dashboard'
//mixins
import loading from '@/mixins/Loading.js'

export default {
  mixins: [loading],
  props:{
    refresh:{
      type:Boolean,
      default:false,
    }
  },
  components: {
    VueApexCharts,
    CardHeader,
  },
  computed: {
    isLoading() {
      return this.loading.compliance_donut
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('compliance-donut-loading')
      } else {
        this.closeLoading('compliance-donut-loading')
      }
    },
  },
  data() {
    return {
      loading: {
        Compliance_donut: false,
      },
      series: [],
      chartOptions: {
        labels: [],
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  formatter: function (w) {
                    let total = 0
                    let number
                    let numberOut = 0
                    w.globals.seriesTotals.forEach((element) => {
                      total = total + parseInt(element)
                    })
                    let indice =
                      w.globals.seriesNames.indexOf('Not in Compliance')

                    number = total - parseInt(w.globals.seriesTotals[indice])
                    if (number != NaN) {
                      numberOut = Math.round((number * 100) / total)
                    }
                    if (indice == -1) numberOut = 100
                    return numberOut + '%'
                  },
                },
                name: {
                  show: false,
                },
                value: {
                  show: true,
                  fontSize: '30px',
                  color: '#fff',
                },
              },
            },
          },
        },
        chart: {
          id: 'donut-compliance',
        },
        tooltip: {
          enabled: true,
          fillSeriesColor: false,
          marker: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
          stroke:{
         colors:['#273045']
        },
      },
      complianceData: [],
      colors: [],
      loading: {
        compliance_donut: false,
      },
    }
  },
  mounted() {
    this.getInfo()
    if(this.refresh === true){
      var v = this
      setInterval(function () {
        v.getInfo()
      }, process.env.VUE_APP_CHART_RELOAD_TIME)
    }
  },
  methods: {
    getInfo() {
      this.loading.compliance_donut = true
      request
        .complianceDonut()
        .then((res) => {
          this.complianceData = res.data.data
          this.fillChartData(this.complianceData)
        })
        .catch((err) => {
          console.log(err)
          this.loading.compliance_donut = false
        })
    },
    fillChartData(dataToChart) {
      if (this.complianceData.length == 0) {
        this.series = [1]
        this.chartOptions.labels = ['NO INFO']
        this.colors = ['#626262']
        this.resertDonut()
      } else {
        for (let i = 0; i < this.complianceData.length; i++) {
          this.chartOptions.labels[i] = this.complianceData[i].status_name
          this.series[i] = parseInt(this.complianceData[i].amount)
          this.colors[i] = this.complianceData[i].status_color
        }
        this.restartDonut()
      }
    },
    restartDonut() {
      ApexCharts.exec(
        'donut-compliance',
        'updateOptions',
        {
          fill: {
            colors: this.colors,
          },
          labels: this.chartOptions.labels,
          series: this.series,
        },
        false,
        true
      )
      this.loading.compliance_donut = false
    },
  },
}
</script>
<style>
</style>